<lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
<div class="text-lg mb-5 font-bold">Hearing Schedule</div>

<form [formGroup]="searchForm" class="bg-fieldset p-4 rounded-lg shadow-sm border border-gray-200"
  (ngSubmit)="searchHandler()">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">

    <div class="w-full">
      <mat-label class="block mb-1 text-sm font-medium">Hearing Date</mat-label>
      <mat-form-field class="w-full" appearance="outline">
        <input formControlName="hearingDate" matInput [matDatepicker]="picker">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="w-full">
      <mat-label class="block mb-1 text-sm font-medium">Hearing Phase</mat-label>
      <mat-form-field class="w-full" appearance="outline">
        <mat-select formControlName="hearingPhaseName">
          @for (phase of hearingPhases; track $index) {
          <mat-option [value]="phase">{{phase}}</mat-option>
          }
        </mat-select>
        <mat-error>Field value required</mat-error>
      </mat-form-field>
    </div>

    <div class="w-full" *ngIf="this.getCourtNameData()?.courtId!==1 && this.getCourtNameData()?.courtId!==2">
      <mat-label class="block mb-1 text-sm font-medium">Case Category</mat-label>
      <mat-form-field class="w-full" appearance="outline">
        <mat-select formControlName="caseCategory">
          @for (category of caseCategories; track $index) {
          <mat-option [value]="category.key">{{category.value}}</mat-option>
          }
        </mat-select>
        <mat-error>Field value required</mat-error>
      </mat-form-field>
    </div>

    <div class="flex gap-3 w-full mt-1 md:mt-5 justify-start">
      <button type="reset" mat-stroked-button color="primary" class="mr-4 w-full md:w-auto"
        (click)="resetHandler()">Reset</button>
      <button type="submit" mat-flat-button color="primary" class="w-full md:w-auto">Search</button>
    </div>
  </div>
</form>

@if (searchFormData()) {
<div class="flex flex-col pb-3 w-full">
  <div class="flex-grow bg-fieldset rounded shadow-sm overflow-hidden">
    <div class="flex px-4 py-3 border-slate-400 border-b items-center bg-gray-50">
      <h2 class="text-lg font-semibold">{{isSupremeFlag || isAppeal?'Appeals for Hearing Schedule':'Cases for Hearing
        Schedule'}}</h2>
    </div>

    <div class="px-0 md:px-4 py-2">
      @if(!isLoading){

      <div class="table-scroll-wrapper">
        <cdk-virtual-scroll-viewport itemSize="48" class="h-60 border w-full min-w-[800px]" maxItemsToRender="10">
          <table mat-table [dataSource]="dataSource" matSort class="case-summery-table virtual-scroll w-full">

            <ng-container [matColumnDef]="column.dataIndex"
              *ngFor="let column of hearingScheduleTbl().columns; let $index = index;">

              @if (column.sortable == false) {
              <th mat-header-cell *matHeaderCellDef [class]="column.headingStyleClass" class="whitespace-nowrap px-4">
                {{column.title}} </th>
              } @else {
              <th mat-header-cell *matHeaderCellDef mat-sort-header="{{column.dataIndex}}"
                [class]="column.headingStyleClass" class="whitespace-nowrap px-4"> {{column.title}} </th>
              }

              <td mat-cell *matCellDef="let row" [class]="column.styleClass" class="px-4">
                @switch (column.dataIndex) {
                @case ('hearingDate') {
                @if(row?.editable) {
                <div class="flex items-center justify-start h-full w-full">
                  <mat-form-field appearance="outline" class="compact-date-field w-full max-w-[140px]">
                    <input [(ngModel)]="row.editedCtrlVal" matInput [matDatepicker]="picker" [min]="today"
                      (dateChange)="onHearingDateChange(row)">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
                } @else {
                <div class="flex items-center justify-start h-full px-2">
                  <span class="text-sm">
                    {{row[column.dataIndex] ? (row[column.dataIndex] | date: 'mediumDate') : '—'}}
                  </span>
                </div>
                }
                }
                @case ('caseNumber') {
                <div class="flex items-center justify-start h-full px-2">
                  <div (click)="caseNumberClickHandler(row)"
                    class="cursor-pointer text-primary hover:underline font-medium text-sm">
                    {{row[column.dataIndex]|| row.caseNumber}}
                  </div>
                </div>
                }
                @case ('actions') {
                <div class="flex items-center justify-end space-x-1 min-w-[100px] h-full">
                  @if(row.editedLoader) {
                  <div matTooltip="Saving updates..." matTooltipPosition="above">
                    <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
                  </div>
                  } @else {
                  @if(row.editable) {
                  <!-- Save Button -->
                  <span [matTooltip]="isSaveDisabled(row) ? 'Fill required fields to save' : 'Save Changes'"
                    matTooltipPosition="above">
                    <button mat-icon-button class="action-btn save-btn" [disabled]="isSaveDisabled(row)"
                      (click)="onSave(row)">
                      <mat-icon fontIcon="check_circle"></mat-icon>
                    </button>
                  </span>

                  <!-- Cancel Edit Button -->
                  <button mat-icon-button class="action-btn cancel-btn" matTooltip="Adjourn Hearing"
                    matTooltipPosition="above" (click)="onCancel(row)">
                    <mat-icon fontIcon="cancel"></mat-icon>
                  </button>
                  } @else {
                  <!-- Edit Button with Contextual Tooltip -->
                  <span matTooltip="Edit Hearing" matTooltipPosition="above">
                    <button mat-icon-button class="action-btn edit-btn" [disabled]="!row.canEdit"
                      (click)="onEditToggle(row)">
                      <mat-icon fontIcon="edit"></mat-icon>
                    </button>
                  </span>

                  <!-- Cancel Hearing Date Button -->
                  @if(row.hearingPhaseName === 'Hearing Date Fixed') {
                  <button mat-icon-button class="action-btn cancel-hearing-btn text-warn"
                    matTooltip="Cancel Hearing Date" matTooltipPosition="above"
                    (click)="openCancelHearingDialog(row, commentsDialog)">
                    <mat-icon fontIcon="event_busy"></mat-icon>
                  </button>
                  }
                  }
                  }
                </div>
                }
                @case ('sessionName') {
                @if(row?.editable && (getCourtNameData()?.courtId===1 || getCourtNameData()?.courtId===2)) {
                <div class="flex items-center justify-start h-full w-full">
                  <mat-form-field appearance="outline" class="density-compact w-full min-w-[120px]">
                    <mat-select [(ngModel)]="row.sessionId" (click)="getCourtSessions()"
                      (selectionChange)="onSessionSelected(row, $event.value)" placeholder="Select Session">
                      <mat-option *ngFor="let session of sessionList" [value]="session.id">
                        {{ session.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                } @else {
                <div class="flex items-center justify-start h-full px-2">
                  <span class="text-sm">{{ row.sessionName || '—' }}</span>
                </div>
                }
                }
                @case ('panelName') {
                @if(row?.editable && (getCourtNameData()?.courtId===1 || getCourtNameData()?.courtId===2)) {
                <div class="flex items-center justify-start h-full w-full">
                  <mat-form-field appearance="outline" class="density-compact w-full min-w-[120px]">
                    <mat-select [(ngModel)]="row.panelId" placeholder="Select Panel"
                      (selectionChange)="onPanelSelected(row, $event.value)">
                      <mat-option *ngFor="let panel of panelList" [value]="panel.id">
                        {{ panel.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                } @else {
                <div class="flex items-center justify-start h-full px-2">
                  <span class="text-sm">{{ row.panelName || '—' }}</span>
                </div>
                }
                }
                @case ('courtRoom') {
                @if(row?.editable && (getCourtNameData()?.courtId===1 || getCourtNameData()?.courtId===2)) {
                <div class="flex items-center justify-start h-full w-full">
                  <mat-form-field appearance="outline" class="density-compact w-full min-w-[120px]">
                    <mat-select [(ngModel)]="row.courtUnitTypeId" placeholder="Select Court Room"
                      (selectionChange)="onCourtRoomSelected(row, $event.value)">
                      <mat-option *ngFor="let room of courtRoom" [value]="room.courtUnitTypeId">
                        {{ room.courtUnitTypeName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                } @else {
                <div class="flex items-center justify-start h-full px-2">
                  <span class="text-sm">{{ row.courtUnitTypeName || '—' }}</span>
                </div>
                }
                }
                @default {
                <div class="flex items-center justify-start h-full px-2">
                  <span class="text-sm">{{row[column.dataIndex] || '—'}}</span>
                </div>
                }
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns();" [class.editing-mode]="row.editable"
              class="hover:bg-gray-50 border-b border-gray-100">
            </tr>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
      } @else {
      <div class="flex justify-center items-center h-40">
        <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
      </div>
      }
    </div>
  </div>
</div>}

@if (ispanel){
@if(originalPanel.length!==0 || changedPanel.length!==0){
<div class="panel-justice-tab mt-6">
  <mat-tab-group animationDuration="0ms" class="bg-white rounded border">
    <mat-tab label="Panel Justice">
      <div class="panel-justice-container">

        <div class="panel-section">
          <div class="panel-header">Original Panel</div>
          <div class="px-0">
            <div class="table-scroll-wrapper">
              <cdk-virtual-scroll-viewport itemSize="48" class="h-60 border w-full" maxItemsToRender="10">
                <table mat-table [dataSource]="originalPanel" class="case-summery-table virtual-scroll w-full">
                  <ng-container matColumnDef="justiceId">
                    <th mat-header-cell *matHeaderCellDef class="px-4">Justice ID</th>
                    <td mat-cell *matCellDef="let element" class="px-4">{{ element.prtId }}</td>
                  </ng-container>
                  <ng-container matColumnDef="justiceName">
                    <th mat-header-cell *matHeaderCellDef class="px-4">Justice Name</th>
                    <td mat-cell *matCellDef="let element" class="px-4">{{ element.prtName }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                  <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </div>

        <div class="panel-section">
          <div class="panel-header">Changed Panel</div>
          <div class="px-0">
            <div class="table-scroll-wrapper">
              <cdk-virtual-scroll-viewport itemSize="48" class="h-60 border w-full" maxItemsToRender="10">
                <table mat-table [dataSource]="changedPanel" class="case-summery-table virtual-scroll w-full">
                  <ng-container matColumnDef="justiceId">
                    <th mat-header-cell *matHeaderCellDef class="px-4">Justice ID</th>
                    <td mat-cell *matCellDef="let element" class="px-4">{{ element.prtId }}</td>
                  </ng-container>
                  <ng-container matColumnDef="justiceName">
                    <th mat-header-cell *matHeaderCellDef class="px-4">Justice Name</th>
                    <td mat-cell *matCellDef="let element" class="px-4">{{ element.prtName }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                  <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
}
}
@if (isAppeal){
<!-- @if(panelList.length!==0){ -->
<div class="panel-section">
  <div class="panel-header">Panel Judges</div>
  <div class="px-0">
    <div class="table-scroll-wrapper">
      <cdk-virtual-scroll-viewport itemSize="48" class="h-60 border w-full" maxItemsToRender="10">
        <table mat-table [dataSource]="originalPanel" class="case-summery-table virtual-scroll w-full">
          <ng-container matColumnDef="justiceName">
            <th mat-header-cell *matHeaderCellDef class="px-4">Panel Judge(s)</th>
            <td mat-cell *matCellDef="let element" class="px-4">{{ element.prtName }}</td>
          </ng-container>
          <ng-container matColumnDef="justiceId">
            <th mat-header-cell *matHeaderCellDef class="px-4">Judge ID</th>
            <td mat-cell *matCellDef="let element" class="px-4">{{ element.prtId }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
        </table>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>


<!-- } -->
}
@if (selectedComment()) {
<div class="mt-4">
  <div class="bg-fieldset rounded-lg shadow-sm border border-gray-200 overflow-hidden">
    <div class="px-4 py-3 border-b bg-gray-50">
      <h2 class="text-lg font-semibold">Judge/Panel Assignment Comments</h2>
    </div>

    <div class="p-4">
      {{ selectedComment() }}
    </div>
  </div>
</div>
}
@if (caseNumber()) {
<div class="mt-4">
  <app-case-documents [caseNumber]="caseNumber()" [isSupreme]="isSupremeFlag"></app-case-documents>
</div>
}



<dialog #commentsDialog
  style="padding: 24px; border-radius: 16px; border: 1px solid #dcdcdc; width: 440px; box-shadow: 0 4px 20px rgba(0,0,0,0.15); font-family: sans-serif;">

  <h3 style="margin-top: 0; color:#006633; font-size: 18px; margin-bottom: 8px;">Comments</h3>
  <p style="color: #666; font-size: 14px; margin-bottom: 16px; line-height: 1.4;">
    Please provide comments for cancelling hearing date for Case:
    <strong>{{ selectedRowForCancel?.caseNumber }}</strong>
  </p>

  <!-- Curved Textarea Input Box -->
  <textarea [(ngModel)]="userComments" rows="4"
    style="width: 100%; box-sizing: border-box; padding: 12px; margin-bottom: 20px; border: 1px solid #006633; border-radius: 12px; font-family: inherit; resize: none; outline: none;"
    placeholder="Enter comments...">
  </textarea>

  <!-- Buttons Orientation Row -->
  <div style="text-align: right; gap: 12px; display: flex; justify-content: flex-end; align-items: center;">
    <button type="button" (click)="commentsDialog.close()"
      style="background-color: transparent; color: #333; border: 1px solid #999; padding: 8px 20px; border-radius: 20px; cursor: pointer; font-weight: 500; font-size: 14px;">
      Cancel
    </button>

    <button type="button" [disabled]="!userComments.trim()" (click)="onCancelHearingDate(commentsDialog)"
      [style.opacity]="userComments.trim() ? '1' : '0.5'"
      style="background-color: #006633; color: white; border: none; padding: 8px 24px; border-radius: 20px; cursor: pointer; font-weight: 500; font-size: 14px;">
      Save
    </button>
  </div>
</dialog>